import Promise from 'bluebird'
import request from 'superagent'

// Promisify superagent
request.Request.prototype.execAsync = function () {
  const req = this
  return new Promise(function (resolve, reject) {
    req.end(function (er, res) {
      if (er) return reject(er)
      resolve(res)
    })
  })
}

export default request



// WEBPACK FOOTER //
// ./modules/utils/promisifiedRequest.js